import { gql } from 'apollo-angular';

export const CORE_APPLICATION_FIELDS = gql`
  fragment application on Application {
    alphaII
    batch277ca
    batch277u
    batchCsv
    batchHumanReadable
    batchMachineReadable
    batchxml
    careTracker
    code
    description
    ftpKey
    humanReadable271
    inputGenerates999
    message
    newStatements
    rejectPrintClaims
    remit277ca
    remit277u
    remitCsv
    remitCsvDaily
    remitEraSummary
    remitHumanReadable
    remitMachineReadable
    remitXml
    rCM
    genericProvider
    # 		providers
    # 		usersClientsApps
  }
`;

export const getApplications = gql`
  query GetApplications($first: Int!, $where: ApplicationFilterInput) {
    applications(first: $first, where: $where, order: { description: ASC }) {
      nodes {
        alphaII
        batch277ca
        batch277u
        batchCsv
        batchHumanReadable
        batchxml
        careTracker
        code
        description
        ftpKey
        humanReadable271
        message
        rejectPrintClaims
        remit277ca
        remit277u
        # remitcsv
        remitCsvDaily
        remitEraSummary
        remitHumanReadable
        remitXml
      }
    }
  }
`;

export const getApplication = gql`
  query GetApplications($code: String) {
    application(code: $code) {
      ...application
    }
  }
  ${CORE_APPLICATION_FIELDS}
`;

export const getApplicationsForUser = gql`
  query GetApplications(
    $first: Int!
    $where: ApplicationFilterInput
    $order: [ApplicationSortInput!]
    $after: String
  ) {
    applications(first: $first, where: $where, order: $order, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        code
        description
      }
    }
  }
`;

export const getApplicationsWithProviders = gql`
  query GetApplications($first: Int!, $where: ApplicationFilterInput) {
    applications(first: $first, where: $where, order: { description: ASC }) {
      nodes {
        alphaII
        batch277ca
        batch277u
        batchCsv
        batchHumanReadable
        batchxml
        careTracker
        code
        description
        ftpKey
        humanReadable271
        message
        rejectPrintClaims
        remit277ca
        remit277u
        # remitcsv
        remitCsvDaily
        remitEraSummary
        remitHumanReadable
        remitXml
        providers {
          account {
            accountNumber
            name
          }
          firstName
          # groupEnrollments: [GroupEnrollment]
          id
          lastName
          lastUpdatedBy
          providerGroupId
        }
      }
    }
  }
`;

export const getStates = gql`
  {
    states(first: 100, order: { code: ASC }) {
      nodes {
        code
        description
      }
    }
  }
`;

export const getBillingTypes = gql`
  {
    billingIdTypes {
      code
      description
    }
  }
`;

export const getFormatTypes = gql`
  query GetFormatTypes($first: Int!, $where: FormatTypeFilterInput) {
    formatTypes(first: $first, where: $where) {
      nodes {
        description
        id
      }
    }
  }
`;
